import React, { useCallback } from "react";
import { OnOffSwitchComponent } from "@common/components/onOffSwitch/OnOffSwitchComponent";
import { IState } from "@common/state/IState";
import { useDispatch, useSelector } from "react-redux";
import {
    umSpPageDataSelector,
    umSpPageSchemeSelector,
    umSpPageSubscriptionsTypesConsentsExtractor,
} from "../_shared/selectors";
import { toggleGeneralConsentOnSubscriptionPreferencesAction } from "../subscriptionPreferences/subscriptionPreferencesActions";

const i18n = {
    smsconsent: "SMS",
    emailconsent: "Email",
    pushconsent: "Push notifications",
    postconsent: "Post notifications",
    noConsents: "No general consents",
};

const selector = (s: IState) => {
    const data = umSpPageDataSelector(s);
    if (!data?.generalConsents) return [];

    const consentsTypesKeys = umSpPageSubscriptionsTypesConsentsExtractor(
        data.subscriptionsTypes,
        umSpPageSchemeSelector(s)
    )[1];

    return consentsTypesKeys.map(key => ({
        key,
        value: Boolean(data.generalConsents[key]),
        title: i18n[key],
    }));
};

export function GeneralConsentsComponent({ className }) {
    const consents = useSelector(selector);
    return (
        <div className={className}>
            {consents?.length > 0 ? (
                consents.map(({ key, value, title }) => (
                    <Switch
                        key={key}
                        consentKey={key}
                        data-key={key}
                        label={title}
                        checked={value}
                    />
                ))
            ) : (
                <span>{i18n.noConsents}</span>
            )}
        </div>
    );
}

function Switch({ consentKey, ...props }) {
    const dispatch = useDispatch();
    const onChange = useCallback(() => {
        dispatch(
            toggleGeneralConsentOnSubscriptionPreferencesAction(
                consentKey,
                !props.checked
            )
        );
    }, [consentKey, props.checked]);

    return <OnOffSwitchComponent {...props} onChange={onChange} />;
}
